import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class EngineExt extends ConnectBasicEntityExt {
description: TranslatedEmb;
kind: string;
label: TranslatedEmb;
processCode: string;
valor: Object;
visionCode: string;
}

